module.exports = __webpack_public_path__ + "static/media/next-disabled.70457980.svg";